// extracted by mini-css-extract-plugin
export default {"base":"vp_bsCnT","error":"vp_AtOg_"};